// @ts-nocheck
import { Icon } from "@/components/icons";
import { getSessionState, MOCK } from "@/state/app-store";

// ============================================================
// EasyShare 设计系统 · 通用组件（商务风版本）
// 原则：去渐变 / 去色块 / 中性配色 / 极简阴影 / 精致细节
// ============================================================

const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

// ---------- 数字格式化 ----------
function fmtNum(n) {
  if (n == null) return "-";
  if (Math.abs(n) >= 1e9) return (n / 1e9).toFixed(2) + "B";
  if (Math.abs(n) >= 1e6) return (n / 1e6).toFixed(2) + "M";
  if (Math.abs(n) >= 1e4) return (n / 1e3).toFixed(1) + "K";
  return n.toLocaleString();
}
function fmtMoney(n) {
  return "$" + (n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });
}
function fmtPercent(n) { return (n || 0).toFixed(1) + "%"; }

// ---------- Toast ----------
function toast(msg, type = "success") {
  const styles = {
    success: { bg: "bg-white border-ok-500", iconBg: "bg-ok-50 text-ok-600", iconName: "check" },
    error:   { bg: "bg-white border-danger-500", iconBg: "bg-danger-50 text-danger-600", iconName: "x" },
    info:    { bg: "bg-white border-brand-500", iconBg: "bg-brand-50 text-brand-700", iconName: "info" },
    warning: { bg: "bg-white border-warn-500", iconBg: "bg-warn-50 text-warn-600", iconName: "alert" },
  };
  const s = styles[type] || styles.info;
  const el = document.createElement("div");
  el.className = `toast ${s.bg} border-l-4 px-4 py-2.5 rounded-md shadow-pop text-sm flex items-center gap-2.5 min-w-[280px] text-ink-900`;
  el.innerHTML = `<span class="w-6 h-6 rounded-md ${s.iconBg} flex items-center justify-center">${Icon[s.iconName]({ size: 14 })}</span><span class="font-medium">${msg}</span>`;
  $("#toast-container").appendChild(el);
  setTimeout(() => {
    el.style.opacity = "0";
    el.style.transform = "translateX(120%)";
    el.style.transition = "0.25s ease";
    setTimeout(() => el.remove(), 250);
  }, 2400);
}

// ---------- Confirm Modal（全局操作反馈样式） ----------
function confirmModal({ title, content, confirmText = "确认", cancelText = "取消", onConfirm }) {
  // 保证同一时刻只有一个操作反馈弹窗
  document.getElementById("modal-mask")?.remove();
  const html = `
    <div class="fixed inset-0 z-50 flex items-center justify-center" id="modal-mask">
      <div class="absolute inset-0 bg-slate-900/35 backdrop-blur-[1px]"></div>
      <div class="relative bg-white rounded-xl shadow-pop w-[440px] p-6 animate-fade-up border border-ink-200">
        <h3 class="text-lg font-semibold text-ink-900 leading-none">${title}</h3>
        <div class="mt-3 text-sm leading-6 text-ink-700">${content}</div>
        <div class="mt-7 flex justify-end gap-3">
          <button id="modal-cancel" class="px-4 py-2 rounded-lg border border-ink-200 bg-white text-sm font-medium text-ink-700 hover:bg-ink-50">${cancelText}</button>
          <button id="modal-confirm" class="px-4 py-2 rounded-lg bg-brand-900 text-sm font-medium text-white hover:bg-brand-800 shadow-soft">${confirmText}</button>
        </div>
      </div>
    </div>`;
  document.body.insertAdjacentHTML("beforeend", html);
  $("#modal-cancel").onclick = () => $("#modal-mask").remove();
  $("#modal-confirm").onclick = () => {
    $("#modal-mask").remove();
    onConfirm && onConfirm();
  };
}

// ---------- 权限 ----------
function hasPerm(key) {
  const session = getSessionState();
  const perms = session.permissions || MOCK.PERMISSIONS[session.currentRole as keyof typeof MOCK.PERMISSIONS];
  return perms?.[key] === true;
}

// 全局保存/提交类操作反馈：统一走确认弹窗样式
window.confirmAction = function (title, content, confirmText = "确认", successMsg = "操作成功", redirect = "", type = "success") {
  confirmModal({
    title,
    content,
    confirmText,
    onConfirm: () => {
      if (successMsg) toast(successMsg, type);
      if (redirect) setTimeout(() => navigate(redirect), 600);
    },
  });
};

// ---------- 状态徽章（极简） ----------
function statusBadge(status) {
  const map = {
    active:         { text: "运行中",     fg: "text-ok-700",      bg: "bg-ok-50",      dot: "bg-ok-500" },
    draft:          { text: "草稿",       fg: "text-warn-700",    bg: "bg-warn-50",    dot: "bg-warn-500" },
    inactive:       { text: "已停用",     fg: "text-ink-600",     bg: "bg-ink-100",    dot: "bg-ink-400" },
    configured:     { text: "已配置",     fg: "text-ok-700",      bg: "bg-ok-50",      dot: "bg-ok-500" },
    inherited:      { text: "继承游戏",   fg: "text-brand-700",   bg: "bg-brand-50",   dot: "bg-brand-500" },
    not_configured: { text: "未配置",     fg: "text-ink-600",     bg: "bg-ink-100",    dot: "bg-ink-400" },
    released:       { text: "已发布",     fg: "text-ok-700",      bg: "bg-ok-50",      dot: "bg-ok-500" },
    testing:        { text: "测试中",     fg: "text-warn-700",    bg: "bg-warn-50",    dot: "bg-warn-500" },
    deprecated:     { text: "已废弃",     fg: "text-ink-600",     bg: "bg-ink-100",    dot: "bg-ink-400" },
  };
  const m = map[status] || { text: status, fg: "text-ink-600", bg: "bg-ink-100", dot: "bg-ink-400" };
  return `<span class="badge ${m.bg} ${m.fg}"><span class="dot ${m.dot}"></span>${m.text}</span>`;
}

// ---------- 趋势箭头（极简） ----------
function trendArrow(delta) {
  if (delta > 0) {
    return `<span class="inline-flex items-center gap-0.5 text-[11px] font-semibold text-ok-700 num">${Icon.trendingUp({ size: 12 })} ${delta}%</span>`;
  }
  if (delta < 0) {
    return `<span class="inline-flex items-center gap-0.5 text-[11px] font-semibold text-danger-700 num">${Icon.trendingDown({ size: 12 })} ${Math.abs(delta)}%</span>`;
  }
  return `<span class="inline-flex items-center gap-0.5 text-[11px] font-medium text-ink-400 num">— 0%</span>`;
}

// ---------- KPI 卡（极简版） ----------
function statCard({ label, value, delta, icon, color = "brand", sub = "" }) {
  // 不使用渐变背景，统一白底；左侧用细色条标识类别
  const colorMap = {
    brand:  { bar: "bg-brand-700",  iconBg: "bg-brand-50  text-brand-700",  iconName: "share" },
    ok:     { bar: "bg-ok-600",     iconBg: "bg-ok-50     text-ok-700",     iconName: "check" },
    green:  { bar: "bg-ok-600",     iconBg: "bg-ok-50     text-ok-700",     iconName: "trendingUp" },
    blue:   { bar: "bg-brand-500",  iconBg: "bg-brand-50  text-brand-700",  iconName: "mousePointer" },
    amber:  { bar: "bg-warn-600",   iconBg: "bg-warn-50   text-warn-700",   iconName: "dollar" },
    rose:   { bar: "bg-danger-600", iconBg: "bg-danger-50 text-danger-700", iconName: "alert" },
    pink:   { bar: "bg-brand-700",  iconBg: "bg-brand-50  text-brand-700",  iconName: "link" },
  };
  const p = colorMap[color] || colorMap.brand;
  // 允许 icon 参数是 lucide 名（字符串）或 emoji（兼容旧用法）
  const iconHtml = (icon && Icon[icon])
    ? Icon[icon]({ size: 16 })
    : (icon && typeof icon === "string" && icon.length <= 2 && !Icon[icon])
      ? Icon[p.iconName]({ size: 16 }) // emoji 一律换 lucide
      : Icon[p.iconName]({ size: 16 });

  return `
    <div class="card p-5 relative">
      <div class="absolute left-0 top-3 bottom-3 w-0.5 ${p.bar} rounded-r"></div>
      <div class="flex items-start justify-between">
        <div>
          <div class="text-xs text-ink-500 font-medium">${label}</div>
          <div class="num text-[26px] font-semibold text-ink-900 mt-1.5 leading-none">${value}</div>
          ${sub ? `<div class="text-xs text-ink-400 mt-1.5">${sub}</div>` : ""}
        </div>
        <div class="icon-tile ${p.iconBg}">${iconHtml}</div>
      </div>
      <div class="mt-3.5 flex items-center gap-2">
        ${trendArrow(delta)}
        <span class="text-[11px] text-ink-400">vs 昨日</span>
      </div>
    </div>
  `;
}

// ---------- 渠道 chip ----------
function channelChip(channel, opts = {}) {
  const c = typeof channel === "string" ? MOCK.CHANNELS.find((x) => x.code === channel) : channel;
  if (!c) return "";
  const dimmed = opts.disabled ? "opacity-40" : "";
  return `<span class="channel-chip ${dimmed}" title="${c.category_name}">${c.icon} ${c.name}</span>`;
}

// ---------- 渠道能力 badge ----------
function capabilityBadge(value) {
  if (value === true) return `<span class="inline-flex items-center justify-center w-5 h-5 rounded-md bg-ok-50 text-ok-600">${Icon.check({ size: 12 })}</span>`;
  if (value === false) return `<span class="inline-flex items-center justify-center w-5 h-5 rounded-md bg-ink-100 text-ink-400">—</span>`;
  if (value === "limited") return `<span class="inline-flex items-center justify-center w-5 h-5 rounded-md bg-warn-50 text-warn-600">${Icon.alert({ size: 12 })}</span>`;
  return `<span class="text-ink-700 text-xs font-medium">${value}</span>`;
}

// ---------- 页面 Header ----------
function pageHeader({ title, desc, actions = "", icon = "" }) {
  // 商务风：去掉图标渐变方块；改成左侧深蓝细线
  return `
    <div class="mb-5 flex items-start justify-between gap-4 pb-4 border-b border-ink-200">
      <div>
        <h1 class="text-[20px] font-semibold text-ink-900 tracking-tight leading-tight">${title}</h1>
        ${desc ? `<p class="mt-1 text-[13px] text-ink-500">${desc}</p>` : ""}
      </div>
      <div class="flex items-center gap-2 flex-shrink-0">${actions}</div>
    </div>
  `;
}

// ---------- 空状态 ----------
function emptyState({ icon = "info", title, desc, action = "" }) {
  const iconHtml = Icon[icon] ? Icon[icon]({ size: 24, color: "#94A3B8" }) : "";
  return `
    <div class="card py-16 flex flex-col items-center text-center">
      <div class="w-14 h-14 rounded-lg bg-ink-50 border border-ink-200 flex items-center justify-center mb-3">${iconHtml}</div>
      <div class="text-sm font-semibold text-ink-900">${title}</div>
      ${desc ? `<div class="mt-1 text-xs text-ink-500 max-w-md">${desc}</div>` : ""}
      ${action ? `<div class="mt-4">${action}</div>` : ""}
    </div>
  `;
}

// ---------- 按钮 ----------
function primaryBtn(text, opts = {}) {
  const { onclick = "", icon = "" } = opts;
  const iconHtml = icon && Icon[icon] ? Icon[icon]({ size: 14 }) : "";
  return `<button onclick="${onclick}" class="btn-primary">${iconHtml}${text}</button>`;
}
function ghostBtn(text, opts = {}) {
  const { onclick = "", icon = "" } = opts;
  const iconHtml = icon && Icon[icon] ? Icon[icon]({ size: 14 }) : "";
  return `<button onclick="${onclick}" class="btn-ghost">${iconHtml}${text}</button>`;
}

// ---------- Step indicator ----------
function stepIndicator(steps, current) {
  return `
    <div class="flex items-center mb-8">
      ${steps.map((s, i) => {
        const state = i < current ? "done" : i === current ? "active" : "todo";
        return `
          <div class="flex items-center" ${i === steps.length - 1 ? "" : 'style="flex:1"'}>
            <div class="flex flex-col items-center">
              <div class="step-dot ${state}">${state === "done" ? Icon.check({ size: 14 }) : i + 1}</div>
              <div class="text-[11px] mt-2 ${state === "active" ? "text-brand-900 font-semibold" : "text-ink-500"}">${s}</div>
            </div>
            ${i === steps.length - 1 ? "" : `<div class="step-line ${i < current ? "done" : ""}"></div>`}
          </div>`;
      }).join("")}
    </div>
  `;
}

// ============================================================
// ECharts 商务主题
// ============================================================
const BUSINESS_COLORS = ["#1E3A8A", "#475569", "#0F766E", "#B45309", "#7C2D12", "#3B82F6", "#94A3B8", "#15803D"];

function chartTooltip(extra = {}) {
  return {
    trigger: "axis",
    backgroundColor: "#0F172A",
    borderWidth: 0,
    padding: [10, 14],
    textStyle: { color: "#fff", fontSize: 12, fontFamily: "Inter, system-ui" },
    extraCssText: "border-radius: 6px; box-shadow: 0 8px 24px rgba(15,23,42,0.18);",
    axisPointer: {
      type: "line",
      lineStyle: { color: "#94A3B8", width: 1, type: "dashed" },
    },
    ...extra,
  };
}

function chartXAxis(data) {
  return {
    type: "category",
    data,
    boundaryGap: false,
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { color: "#64748B", fontSize: 11, margin: 12 },
  };
}
function chartYAxis(opts = {}) {
  return {
    type: "value",
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { color: "#94A3B8", fontSize: 11, formatter: (v) => fmtNum(v) },
    splitLine: { lineStyle: { color: "#F1F5F9", type: "solid" } },
    ...opts,
  };
}

function chartLineSeries(name, data, opts = {}) {
  const { color = "#1E3A8A", area = false, smooth = true } = opts;
  return {
    name,
    type: "line",
    smooth,
    showSymbol: false,
    symbol: "circle",
    symbolSize: 6,
    emphasis: { focus: "series" },
    lineStyle: { width: 1.8, color },
    itemStyle: { color, borderColor: "#fff", borderWidth: 2 },
    areaStyle: area
      ? {
          color: {
            type: "linear", x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: color + "1A" },
              { offset: 1, color: color + "00" },
            ],
          },
        }
      : null,
    data,
  };
}

function chartBarSeries(name, data, opts = {}) {
  const { color = "#1E3A8A", barWidth = 14, yAxisIndex = 0 } = opts;
  return {
    name,
    type: "bar",
    barWidth,
    yAxisIndex,
    itemStyle: { borderRadius: [2, 2, 0, 0], color },
    emphasis: { itemStyle: { opacity: 0.85 } },
    data,
  };
}

export const UI = {
  $, $$, fmtNum, fmtMoney, fmtPercent,
  toast, confirmModal, hasPerm,
  statusBadge, trendArrow,
  statCard,
  channelChip, capabilityBadge,
  pageHeader, emptyState, primaryBtn, ghostBtn,
  stepIndicator,
  BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries,
};

// 兼容旧调用
(UI as any).bigKpiCard = UI.statCard;
window.UI = UI;

declare global {
  interface Window {
    UI: typeof UI;
    confirmAction: typeof window.confirmAction;
  }
}
